import { render, staticRenderFns } from "./tableArticle.vue?vue&type=template&id=a2d48d80&"
import script from "./tableArticle.vue?vue&type=script&lang=js&"
export * from "./tableArticle.vue?vue&type=script&lang=js&"
import style0 from "./tableArticle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports